import { HTTP } from '@/http-common'
import router from '@/router'
import * as messages from '@/assets/data/messages'
import { MessageBox } from 'element-ui'
import { Loading } from 'element-ui'
import { Message } from 'element-ui'

const state = {
  user: null,
  access: {
    token: sessionStorage.getItem('access_token') || null,
    expires: sessionStorage.getItem('expires_in') || null
  },
  mentor: null,
  subscriptionStatus: null,
  checkoutLink: null,
  chargebeeAccountLink: null,
  signUpStep: 0,
  loading: null,
  signupParams: null,
  now: new Date()
}

const getters = {
  access: s => s.access,
  user: s => s.user,
  mentor: s => s.mentor,
  messageBox: s => s.messageBox,
  signUpStep: s => s.signUpStep,
  checkoutLink: s => s.checkoutLink,
  signupParams: s => s.signupParams,
  subscriptionStatus: s => s.subscriptionStatus,
  chargebeeAccountLink: s => s.chargebeeAccountLink //create a check for is paid.
}

const actions = {
  login({ commit, dispatch }, authForm) {
    commit('START_LOADING')
    HTTP.post('/oauth/token', authForm)
      .then(response => {
        commit('SET_ACCESS', response.data)
        dispatch('getUser').then(() => {
          // TODO only .then user specific data else just get
          dispatch('getAllData')
          router.push({ name: 'Home' })
        })
      })
      .catch(error => {
        if (
          error.response.data.error === 'invalid_user' ||
          error.response.data.error === 'invalid_password'
        ) {
          commit('STOP_LOADING')
          commit('SET_MESSAGE_BOX', messages.LOGIN_ERROR)
        }
      })
  },
  getAllData({ dispatch, commit }) {
    dispatch('getSubscriptionStatus')
    dispatch('getMentor')
    commit('STOP_LOADING')
    dispatch('getAllcontent')
    dispatch('getChargebeeAccountLink')
    dispatch('getContacts')
  },
  getUser({ commit }) {
    return new Promise(resolve => {
      HTTP.get('users/me').then(response => {
        commit('SET_USER', response.data)
        resolve()
      })
    })
  },
  getMentor({ commit, getters }) {
    HTTP.get('mentors/' + getters.user.MyMentorId).then(response => {
      commit('SET_MENTOR', response.data)
    })
  },
  signUp({ commit, dispatch, getters }, newUser) {
    commit('START_LOADING')
    HTTP.post('users', newUser)
      .then(response => {
        commit('SET_ACCESS', response.data)

        dispatch('getUser').then(() => {
          // todo if is not mentor but is upgrading.
          if (getters.user.IsMentor) {
            commit('STOP_LOADING')

            dispatch('getAllData')
            router.push({ name: 'Home' })
          } else {
            dispatch('getChargbeeCheckout', false)
          }
        })
      })
      .catch(error => {
        commit('STOP_LOADING')

        if (error) {
          commit('SET_MESSAGE_BOX_CONFIRM', messages.SIGNUP_ERROR)
        }
      })
  },
  upgrade({ commit, dispatch }, authForm) {
    HTTP.post('/oauth/token', authForm)
      .then(response => {
        commit('SET_ACCESS', response.data)
        dispatch('getUser').then(() => {
          // TODO only .then user specific data else just get
          if (getters.user.IsMentor) {
            dispatch('getAllData')
            router.push({ name: 'Home' })
          } else {
            dispatch('getChargbeeCheckout', true)
          }
        })
      })
      .catch(error => {
        if (
          error.response.data.error === 'invalid_user' ||
          error.response.data.error === 'invalid_password'
        ) {
          commit('SET_MESSAGE_BOX', messages.LOGIN_ERROR)
        }
      })
  },
  signUpShared({ commit, dispatch }, newUser) {
    commit('START_LOADING')
    HTTP.post('users', newUser)
      .then(response => {
        commit('SET_ACCESS', response.data)
        dispatch('getUser').then(() => {
          dispatch('getAllData')
        })
      })
      .catch(error => {
        if (error) {
          commit('SET_MESSAGE_BOX_CONFIRM', messages.SIGNUP_ERROR)
        }
      })
  },
  getChargbeeCheckout({ commit, getters }, isUpgrade) {
    const params = getters.signupParams
    const subscriptionPlan =
      params && params.subscription && params.subscription !== 'null'
        ? params.subscription
        : isUpgrade
        ? 'mentor-subscription'
        : 'lifetime-oil-user-usa'
    const optionalRef =
      params && params.ref && params.ref !== 'null' ? '?ref=' + params.ref : ''
    HTTP.get(
      `chargebee/${subscriptionPlan}/${getters.user.Id + optionalRef}`
    ).then(response => {
      commit('STOP_LOADING')
      commit('SET_CHECKOUT_LINK', response.data)
    })
  },
  getSubscriptionStatus({ commit, getters }) {
    HTTP.get('Chargebee/SubscriptionStatus/' + getters.user.Id).then(
      response => {
        commit('SET_SUBSCRIPTION_STATUS', response.data)
      }
    )
  },
  reactivateSubscription({ dispatch, getters }) {
    HTTP.post(
      'Chargebee/ReactivateSubscription/' +
        getters.subscriptionStatus.SubscriptionId
    ).then(() => {
      // const newUser = Object.assign({}, getters.user, { IsMentor: true })
      // dispatch('updateUser', newUser)
      dispatch('getSubscriptionStatus')
    })
  },
  getChargebeeAccountLink({ commit, getters }) {
    return new Promise(resolve => {
      HTTP.get('Chargebee/CustomerPortal/' + getters.user.Id).then(response => {
        commit('SET_CHARGEBEE_ACCOUNT_LINK', response.data)
        resolve()
      })
    })
  },
  updateUser({ commit }, user) {
    HTTP.put('users', user).then(response => {
      commit('SET_USER', response.data)
      commit('SET_MESSAGE', messages.USER_UPDATED)
    })
  },
  updatePassword({ commit }, password) {
    HTTP.put('Users/ChangePassword', password)
      .then(response => {
        if (response.data) commit('SET_MESSAGE', messages.PASSWORD_UPDATED)
      })
      .catch(() => commit('SET_MESSAGE_BOX', messages.PASSWORD_UPDATE_ERROR))
  },
  resetPassword({ commit }, email) {
    HTTP.get('users/PasswordReset?email=' + email).then(response => {
      if (response.data) {
        commit('SET_MESSAGE', messages.PASSWORD_RESET_SENT)
        router.push({ name: 'Login' })
      } else {
        commit('SET_MESSAGE', messages.PASSWORD_RESET_NOT_SENT)
      }
    })
  },
  confirmResetPassword({ commit }, resetPassword) {
    HTTP.post('users/FinishPasswordReset', resetPassword)
      .then(() => {
        commit('SET_MESSAGE', messages.PASSWORD_UPDATED)
        router.push({ name: 'Login' })
      })
      .catch(() => commit('SET_MESSAGE', messages.PASSWORD_RESET_NOT_SENT))
  },
  signUpSucess({ commit, dispatch }) {
    dispatch('getUser').then(() => {
      dispatch('getAllData')
      commit('COMPLETE_CHECKOUT')
    })
  }
}

const mutations = {
  SET_USER(s, user) {
    s.user = user
  },
  SET_ACCESS(s, tokenData) {
    sessionStorage.setItem('access_token', tokenData.access_token)
    let now = new Date()
    let expiresDate = now.setSeconds(now.getSeconds() + tokenData.expires_in)
    sessionStorage.setItem('expires_in', expiresDate)
    s.access.token = tokenData.access_token
    s.access.expires = expiresDate
    HTTP.defaults.headers.common['Authorization'] = `Bearer ${
      tokenData.access_token
    }`
  },
  SET_ACCESS_REFRESH(s) {
    HTTP.defaults.headers.common['Authorization'] = `Bearer ${s.access.token}`
  },
  LOGOUT(s) {
    sessionStorage.clear()
    s.user = null
    s.access.token = null
    s.access.expires = null
    HTTP.interceptors.request.eject(s.interceptor)
    location.reload()
  },
  ERROR_LOGOUT(s) {
    sessionStorage.clear()
    s.user = null
    s.access.token = null
    s.access.expires = null
    router.push({ name: 'Login' })
    MessageBox.alert('Please check your internet connection.', 'Server Error')
    HTTP.interceptors.request.eject(s.interceptor)
    location.reload()
  },
  SET_MESSAGE_BOX(s, message) {
    MessageBox.alert(message.text, message.title, message.options)
  },
  SET_MESSAGE_BOX_CONFIRM(s, message) {
    MessageBox.confirm(message.text, message.title, message.options)
  },
  SET_MESSAGE(s, message) {
    Message(Object.assign({}, message))
  },
  SET_MENTOR(s, mentor) {
    s.mentor = mentor
  },
  SET_SUBSCRIPTION_STATUS(s, status) {
    s.subscriptionStatus = status
  },
  SET_CHECKOUT_LINK(s, link) {
    s.checkoutLink = link
    s.signUpStep = 1
  },
  COMPLETE_CHECKOUT(s) {
    s.signUpStep = 2
  },
  START_LOADING(s) {
    const options = {
      lock: true,
      // text: 'Loading',
      background: 'rgba(0, 0, 0, 0.7)'
    }
    s.loading = Loading.service(options)
  },
  STOP_LOADING(s) {
    if (s.loading) s.loading.close()
  },
  SET_CHARGEBEE_ACCOUNT_LINK(s, link) {
    s.chargebeeAccountLink = link
  },
  SET_SIGNUP_PARAMS(s, params) {
    s.signupParams = params
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
